module.exports = __webpack_public_path__ + "static/media/rating.af44777a.png";